var Enum = Enum || { MEEDY : {}};

Enum.REFUNDATION_STATUS = {
    HAS_REFUND: 'HAS_REFUND',
    NO_REFUND: 'NO_REFUND',
    NOT_CHECKED: 'NOT_CHECKED',
    PROBLEM_WHILE_CHECKING: 'PROBLEM_WHILE_CHECKING'
};

Object.freeze(Enum.REFUNDATION_STATUS);